import { createActions, createReducer } from 'reduxsauce'

import ArquivosAnexosService from '../../servicos/ArquivosAnexosService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaArquivosPrestacaoContasAnualInicio: [],
    buscaArquivosPrestacaoContasAnualSucesso: ['arquivosPrestacaoContasAnual'],
    buscaArquivosPrestacaoContasAnualErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaArquivosPrestacaoContasAnual = filtro => {
    return dispatch => {
        dispatch(Creators.buscaArquivosPrestacaoContasAnualInicio())
        let serv = new ArquivosAnexosService()
        return serv
            .consultarAnexosPrestacaoContasAnual(filtro)
            .then(response => dispatch(Creators.buscaArquivosPrestacaoContasAnualSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaArquivosPrestacaoContasAnualErro(error)))
    }
}

const buscaArquivosPrestacaoContasAnualInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaArquivosPrestacaoContasAnualErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaArquivosPrestacaoContasAnualSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.arquivosPrestacaoContasAnual, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ARQUIVOS_PRESTACAO_CONTAS_ANUAL_INICIO]: buscaArquivosPrestacaoContasAnualInicio,
    [Types.BUSCA_ARQUIVOS_PRESTACAO_CONTAS_ANUAL_ERRO]: buscaArquivosPrestacaoContasAnualErro,
    [Types.BUSCA_ARQUIVOS_PRESTACAO_CONTAS_ANUAL_SUCESSO]: buscaArquivosPrestacaoContasAnualSucesso,
})
